"use strict";

exports.__esModule = true;
exports.EditableSingleDeviceGridElement = EditableSingleDeviceGridElement;
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _Grid = require("../Grid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays an editable operator panel.
 */
function EditableSingleDeviceGridElement(props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 256 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 128 : _props$height;
  var allDevices = _react["default"].useContext(_Device.DeviceListContext);
  allDevices = allDevices.filter(function (d) {
    return d.enabled;
  });
  var device = allDevices.find(function (d) {
    return d.uuid === props.device;
  });
  if (!device) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_Device.DeviceContext.Provider, {
    value: device || allDevices[0]
  }, /*#__PURE__*/_react["default"].createElement(_Grid.EditableGridElement, _extends({}, props, {
    width: width,
    height: height
  })));
}